<template>
    <div>
        <!-- <TopBar
        :title="currentTag"
        v-on:go-back="goBackEmit"
        :show-back-button="true"
        :show-toggle="true"
        class="mb-8"
        /> -->
      <div class="bg-gray-900 relative rounded-lg shadow-md">
        <div class="absolute -top-4 left-0 right-0 flex justify-center">
          <div class="bg-secondary px-4 py-2 rounded-full w-full">
            <h1 class="font-light text-primary text-center">NÃO CONFORME</h1>
          </div>
        </div>
        
        <div class="bg-white rounded-2xl p-4 text-gray-900">
          <label class="block mb-2 mt-6 text-sm font-medium">Selecione a causa</label>
          <div class="flex flex-wrap gap-2 mb-4">
            <button
              v-for="(cause, index) in causes"
              :key="index"
              @click="toggleCause(cause)"
              :class="{
                'bg-gray-800 text-white border-gray-800': selectedCauses.includes(cause),
                'bg-white text-gray-900 border-gray-300': !selectedCauses.includes(cause)
              }"
              class="px-3 py-1 rounded-full text-xs font-medium border transition"
            >
              {{ cause.reason }}
            </button>
          </div>
          
          <label class="block mb-2 text-sm font-medium">Selecione a atividade</label>
          <select v-model="selectedActivity" class="w-full p-2 bg-gray-100 rounded-md mb-4 border-none">
            <option v-for="(activity, index) in activities" :key="index" :value="activity">
              {{ activity.name }}
            </option>
          </select>
        </div>
      </div>

      <div class="flex flex-row gap-2 mt-8">
        <VButton
        :disabled="selectedCauses.length > 0 ? false : true"
        type="solid"
        title="Salvar não conformidade"
        :callback="saveNonConformity"
      />
      </div>
    </div>
  </template>
  
<script setup lang="ts">
import VButton from '@/components/Button/VButton.vue';
import { showDefaultToast } from '@/helpers/toast-models';
import WarrantyApiService from '@/services/WarrantyApiService/WarrantyApiService';
import type { Activity, NonConformityReason } from '@/services/WarrantyApiService/types';
import { useAppStore } from '@/stores/app.store';
import { useUserStore } from '@/stores/user.store';
import { computed, onMounted, ref } from 'vue';
import { useRegisterProductNonCoonformity } from './query';

const appStore = useAppStore();
const userStore = useUserStore();

const operationId = computed(() => userStore.decodedToken?.productionSequenceOperation.operation.id ?? "")

const emit = defineEmits(['clear-non-conformity'])
const manufacturingOrderId = computed(() => appStore.currentManufacturingOrder?.id)

const causes = ref<NonConformityReason[]>([])
const activities = ref<Activity[]>([])

const selectedCauses = ref<NonConformityReason[]>([]);
const selectedActivity = ref<Activity>({id:'',name:''});

const registerProductNonConformityQuery = useRegisterProductNonCoonformity({
    manufacturingOrderId: manufacturingOrderId.value!,
    tagCode: appStore.currentTag || '',
    activityId: selectedActivity,
    nonConformityReasons: selectedCauses,
})

async function fetchNonConformityReasons() {
    const response = await WarrantyApiService.listNonConformityReasons({page:1})
    if (response.isWrong()) {
        throw new Error(response.value.message)
    } else {
        causes.value = response.value.nonConformityReasons
    }  
}

async function fetchActivities() {
  
  const response = await WarrantyApiService.listActivity({operationId: operationId.value,tagCode: appStore.currentTag!})
    if (response.isWrong()) {
        throw new Error(response.value.message)
    } else {
        activities.value = response.value
        selectedActivity.value = activities.value[0]
    }  
}

function toggleCause(cause: NonConformityReason) {
    if (selectedCauses.value.includes(cause)) {
        selectedCauses.value = selectedCauses.value.filter(c => c !== cause);
    } else {
        selectedCauses.value.push(cause);
    }
}

async function saveNonConformity() {
    if (selectedCauses.value.length == 0){
        showDefaultToast("Nenhuma causa selecionada!", "error");
    } else {
        await registerProductNonConformityQuery.refetch();
        if (!registerProductNonConformityQuery.isError.value) {
          appStore.actions.clearCurrentSerialNumber()
          appStore.actions.clearCurrentTag()
          appStore.actions.setCurrentMoProduct(null)
          emit('clear-non-conformity')
        }
    }
}

onMounted(async () => {
  await fetchNonConformityReasons();
  await fetchActivities();
});
</script>


